module.exports = __webpack_public_path__ + "static/media/win-reward-A10.73883e0d.png";